import React from "react";
import { Wrapper } from "../../Wrapper";
import { sustainableDevelopmentGoalsDescriptions } from "../consts/sustainable-development-goals-descriptions";
import styles from "../styles/SustainableDevelopmentGoalsWidget.module.scss";

export const SustainableDevelopmentGoals = ({ data }: any) => (
  <Wrapper>
    <section className={styles.SDGWrapper}>
      <h2 className={styles.title}>UN Sustainable Development Goals</h2>
      <p className={styles.text}>
        {`The '${data.title}' project aligns with the following UN Sustainable Development Goals:`}
      </p>
      <ul className={styles.cards}>
        {data.sustainable_development_goals.map((SDGNumber: number) => (
          <li className={styles.card} key={SDGNumber}>
            <img
              className={styles.cardImage}
              alt={`Sustainable Development Goal #${SDGNumber}`}
              src={`/images/app/sdg/${SDGNumber}.png`}
            />
            <p className={styles.cardText}>
              {sustainableDevelopmentGoalsDescriptions[SDGNumber - 1]}
            </p>
          </li>
        ))}
      </ul>
      <p className={styles.text}>
        Read more about the{" "}
        <a
          href="https://sdgs.un.org/goals"
          target="_blank"
          rel="noopener noreferrer"
          title="Open website (new tab)"
        >
          Sustainable Development Goals
        </a>
      </p>
    </section>
  </Wrapper>
);
